import $ from 'jquery'

const $alertContainer = $('.alert-container')

const setAlert = function (variant, message) {
    const $alert = $(`
        <div class="alert alert-${variant} alert-dismissible fade show" role="alert">
            <h6 class="alert-heading"><i class="fas fa-check mr-3"></i> ${message}</h6>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    `)

    $alertContainer.append($alert)
}

export default setAlert
